import dsbridge from "dsbridge";
/**
 * 所有支持的事件名
 */
export var EventName;
(function (EventName) {
    /**
     * 当App主题改变
     */
    EventName["onThemeChange"] = "onThemeChange";
    /**
     * 当App语言改变
     */
    EventName["onLanguageChange"] = "onLanguageChange";
    /**
     * 当原生登录成功
     */
    EventName["onLoginSuccess"] = "onLoginSuccess";
    /**
     * 当原生推出成功
     */
    EventName["onLogout"] = "onLogout";
    /**
     * 当原生扫码成功
     */
    EventName["onScanSuccess"] = "onScanSuccess";
    /**
     * 切换币种
     */
    EventName["onChangeCoinCode"] = "onChangeCoinCode";
    /**
     * 主播代理开关状态
     */
    EventName["onAnchorProxyStatus"] = "onAnchorProxyStatus";
})(EventName || (EventName = {}));
/**
 * 监听事件
 * @param eventName 事件名称
 * @param callback 事件触发的回掉
 */
export function subscribe(eventName, callback) {
    dsbridge.register(eventName, function (res) {
        callback(res);
    });
}
